var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SoftwareFormEditor',{attrs:{"form-name":"newSoftwareForm"}})
}
var staticRenderFns = []

export { render, staticRenderFns }